import api from "lib/axios";
import { ApiEnvelope, unwrapData } from "services/apiTypes";

export type VideoPlayerSettingsPayload = {
  video_voice_announcement_enabled: boolean;
  video_voice_announcement_interval_seconds: number;
  video_voice_announcement_include_student_id: boolean;
  video_voice_announcement_template_ar: string;
  video_voice_announcement_template_en: string;
  video_watermark_enabled: boolean;
  video_watermark_visible_seconds: number;
  video_watermark_hidden_seconds: number;
  video_watermark_opacity: "low" | "medium" | "high";
};

export const instructorCourseVideoPlayerSettingsService = {
  async get(courseId: number | string): Promise<VideoPlayerSettingsPayload> {
    const response = await api.get<ApiEnvelope<{ data: VideoPlayerSettingsPayload }>>(
      `/instructors/courses/${courseId}/video-player-settings`,
      {
        meta: { toastSuccess: false },
      }
    );
    return unwrapData(response.data)!;
  },

  async update(
    courseId: number | string,
    data: Partial<VideoPlayerSettingsPayload>
  ): Promise<VideoPlayerSettingsPayload> {
    const response = await api.put<ApiEnvelope<{ data: VideoPlayerSettingsPayload }>>(
      `/instructors/courses/${courseId}/video-player-settings`,
      data
    );
    return unwrapData(response.data)!;
  },
};
